export const commonTypography = {
  htmlFontSize: 16, // this is what the `rem` is based on
  fontSize: 14, // this is what default/no-variant MUI.Typography will use
  fontFamily: "'Lato', sans-serif",
};
